import { InflatedListItemProduct, Room } from '../list/ListTypes'
import React from 'react'

export function useProductWithId(products: readonly InflatedListItemProduct[]): [InflatedListItemProduct | null, React.Dispatch<string | null>] {
  const [uid, setUid] = React.useState<string | null>(null)
  const product = products.find(it => it.uid === uid) ?? null

  return [product, setUid]
}

export function useRoomWithId(rooms: readonly Room[]): [Room | null, React.Dispatch<string | null>] {
  const [uid, setUid] = React.useState<string | null>(null)
  const product = rooms.find(it => it.uid === uid) ?? null

  return [product, setUid]
}
